module.exports = __webpack_public_path__ + "static/media/mushroom_green.16f15c24.png";